import React from 'react';


export const EmptyCalendarPlaceholder = React.memo(() => {

	return <>
		<div className="bg-white shadow-sm border-t border-gray-200">
			<div className="mx-auto max-w-7xl py-3 px-4 sm:px-6 lg:px-8 h-12" />
			<div className="bg-gray-50 shadow-sm border-t border-gray-100 h-12" />
		</div>
		<div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">
			<div className="lg:flex lg:h-full lg:flex-col">
				<header className="flex items-center justify-end border-b border-gray-200 pb-4 lg:flex-none">
					<div className="flex h-6 w-px items-center flex-wrap gap-y-2 gap-x-2">
					</div>
				</header>
			</div>
			<div className="shadow ring-1 ring-black ring-opacity-5 lg:flex lg:flex-auto lg:flex-col">
				<div
					className="grid grid-cols-7 gap-px border-b border-gray-300 bg-gray-200 text-center text-xs font-semibold leading-6 text-gray-700 lg:flex-none">
					<div className="bg-white py-2">
						M<span className="sr-only sm:not-sr-only">on</span>
					</div>
					<div className="bg-white py-2">
						T<span className="sr-only sm:not-sr-only">ue</span>
					</div>
					<div className="bg-white py-2">
						W<span className="sr-only sm:not-sr-only">ed</span>
					</div>
					<div className="bg-white py-2">
						T<span className="sr-only sm:not-sr-only">hu</span>
					</div>
					<div className="bg-white py-2">
						F<span className="sr-only sm:not-sr-only">ri</span>
					</div>
					<div className="bg-white py-2">
						S<span className="sr-only sm:not-sr-only">at</span>
					</div>
					<div className="bg-white py-2">
						S<span className="sr-only sm:not-sr-only">un</span>
					</div>
				</div>
				{[...Array(5)].map((x, i) => <div key={i}
																					className="flex bg-gray-200 border-b border-gray-200 text-xs leading-6 text-gray-700 lg:flex-auto">
					<div
						className={`hidden w-full lg:grid lg:grid-cols-7 lg:gap-px`}>
						{[...Array(7)].map((x, i) =>
							<div key={i} className="relative bg-white">
								<div className="flex flex-col justify-between h-full">
									<div className="px-3 py-2">
										<time dateTime="2024-01-11"></time>
									</div>
									<div className="px-3 py-2">
										<div className="w-full animate-pulse">
											<div className="h-4 bg-gray-200 rounded-full w-12 mb-4"></div>
											<div className="h-2.5 bg-gray-200 rounded-full mb-2"></div>
											<div className="h-2.5 bg-gray-200 rounded-full mb-2"></div>
											<div className="h-2.5 bg-gray-200 rounded-full mb-2"></div>
											<div className="h-2.5 bg-gray-200 rounded-full mb-2"></div>
											<div className="h-2.5 bg-gray-200 rounded-full mb-2"></div>
										</div>
									</div>
								</div>
							</div>,
						)}
					</div>
					<div
						className={`lg:hidden w-full grid grid-cols-7 gap-px`}>
						{[...Array(7)].map((x, i) =>
							<div key={i} className="relative bg-white">
								<div className="flex flex-col justify-between h-full">
									<div className="px-3 py-2">
										<time dateTime="2024-01-11"></time>
									</div>
									<div className="px-3 py-2">
										<div className="w-full animate-pulse">
											<div className="h-2.5 bg-gray-200 rounded-full w-8 mb-2.5"></div>
											<div className="h-1.5 bg-gray-200 rounded-full mb-1"></div>
											<div className="h-1.5 bg-gray-200 rounded-full mb-1"></div>
											<div className="h-1.5 bg-gray-200 rounded-full mb-1"></div>
										</div>
									</div>
								</div>
							</div>,
						)}
					</div>
				</div>)}
			</div>
		</div>
	</>;
});